"use strict";

document.addEventListener('DOMContentLoaded', function() {

	var adpPopup = {};

	( function() {
		var self;

		// Helper: get data attribute (converts kebab-case to dataset camelCase)
		function getData(el, key) {
			if (!el || !el.dataset) return undefined;
			// Convert 'open-trigger' to 'openTrigger' for dataset access
			var camel = key.replace(/-([a-z])/g, function(m, c) { return c.toUpperCase(); });
			return el.dataset[camel];
		}

		// Helper: set data attribute on element
		function setData(el, key, value) {
			if (!el) return;
			var camel = key.replace(/-([a-z])/g, function(m, c) { return c.toUpperCase(); });
			el.dataset[camel] = value;
		}

		// Helper: get next sibling matching selector
		function nextSibling(el, selector) {
			var sib = el.nextElementSibling;
			while (sib) {
				if (sib.matches(selector)) return sib;
				sib = sib.nextElementSibling;
			}
			return null;
		}

		// Helper: resolve popup element from event or direct element reference
		function resolveEl(e) {
			return (e instanceof Event) ? e.currentTarget : e;
		}

		adpPopup = {
			sPrevious : window.scrollY,
			sDirection: 'down',

			init: function( e ) {
				self = adpPopup;
				self.popupInit( e );
				self.events( e );
			},

			events: function( e ) {
				// Delegated click events
				document.addEventListener('click', function(e) {
					var close = e.target.closest('.popup-close');
					var accept = e.target.closest('.popup-accept');
					var ageClose = e.target.closest('.age-verification__popup-close');
					var ageNo = e.target.closest('.age-verification__button-no');
					var overlay = e.target.closest('.popup-overlay');

					if (accept) {
						self.acceptPopup(accept);
						self.closePopup(accept);
					} else if (ageClose) {
						self.agePopup(ageClose);
						self.closePopup(ageClose);
					} else if (close) {
						self.closePopup(close);
					}

					if (ageNo) {
						self.ageDeclined();
					}

					if (overlay) {
						document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function(popup) {
							self.closePopup(popup);
						});
					}
				});

				// Key events
				document.addEventListener('keyup', function(e) {
					if ( e.key === 'Escape' ) {
						document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function(popup) {
							self.closePopup(popup);
						});
					}
					if ( e.key === 'F4' ) {
						document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function(popup) {
							self.closePopup(popup);
						});
					}
				});
			},

			popupInit: function( e ) {
				// Track scroll direction
				document.addEventListener('scroll', function() {
					var scrollCurrent = window.scrollY;
					self.sDirection = (scrollCurrent > self.sPrevious) ? 'down' : 'up';
					self.sPrevious = scrollCurrent;
				});

				// Init each popup
				document.querySelectorAll('.popup').forEach(function(popup) {
					// Manual Launch
					if ( 'manual' === getData(popup, 'open-trigger') ) {
						var selector = getData(popup, 'open-manual-selector');
						if ( selector ) {
							document.querySelectorAll(selector).forEach(function(el) {
								el.classList.add('popup-trigger');
							});

							document.addEventListener('click', function(e) {
								var trigger = e.target.closest(selector);
								if (!trigger) return;
								e.preventDefault();
								popup.classList.remove('popup-already-opened');
								self.openPopup(popup);
								if (trigger.classList.contains('popup')) {
									self.closePopup(trigger);
								}
							});
						}
					}

					// Check if popup should display
					if ( !self.isAllowPopup(popup) && !popup.classList.contains('age-verification') ) {
						return;
					}

					self.openTriggerPopup(popup);
				});
			},

			openTriggerPopup: function( e ) {
				var popup = (e instanceof Event) ? this : e;
				var trigger = getData(popup, 'open-trigger');

				// Age Verification
				if ( 'none' === trigger ) {
					var ageVerification = self.getCookie( 'popup-age-' + (getData(popup, 'id') || 0) );
					if (!ageVerification) self.openPopup(popup);
				}

				// Time Delay
				if ( 'delay' === trigger ) {
					setTimeout(function() {
						self.openPopup(popup);
					}, getData(popup, 'open-delay-number') * 1000);
				}

				// Exit Intent
				if ( 'exit' === trigger ) {
					var showExit = true;
					document.addEventListener('mousemove', function(e) {
						var scroll = window.pageYOffset || document.documentElement.scrollTop;
						if ( (e.pageY - scroll) < 7 && showExit ) {
							self.openPopup(popup);
							showExit = false;
						}
					});
				}

				// Scroll Position
				if ( 'scroll' === trigger ) {
					var pointScrollType     = getData(popup, 'open-scroll-type');
					var pointScrollPosition = getData(popup, 'open-scroll-position');

					document.addEventListener('scroll', function() {
						if ( 'px' === pointScrollType && window.scrollY >= pointScrollPosition ) {
							self.openPopup(popup);
						}
						if ( '%' === pointScrollType && self.getScrollPercent() >= pointScrollPosition ) {
							self.openPopup(popup);
						}
					});
				}

				// Accept Agreement
				if ( 'accept' === trigger ) {
					var accept = self.getCookie( 'popup-accept-' + (getData(popup, 'id') || 0) );
					if ( !accept ) self.openPopup(popup);
				}
			},

			closeTriggerPopup: function( e ) {
				var popup = (e instanceof Event) ? this : e;
				var trigger = getData(popup, 'close-trigger');

				// Time Delay
				if ( 'delay' === trigger ) {
					setTimeout(function() {
						self.closePopup(popup);
					}, getData(popup, 'close-delay-number') * 1000);
				}

				// Scroll Position
				if ( 'scroll' === trigger ) {
					var pointScrollType     = getData(popup, 'close-scroll-type');
					var pointScrollPosition = parseFloat(getData(popup, 'close-scroll-position'));
					var initScrollPx        = parseFloat(getData(popup, 'init-scroll-px'));
					var initScrollPercent   = parseFloat(getData(popup, 'init-scroll-percent'));

					document.addEventListener('scroll', function() {
						if ( 'px' === pointScrollType ) {
							if ( 'up' === self.sDirection && window.scrollY < (initScrollPx - pointScrollPosition) ) {
								self.closePopup(popup);
							}
							if ( 'down' === self.sDirection && window.scrollY >= (initScrollPx + pointScrollPosition) ) {
								self.closePopup(popup);
							}
						}
						if ( '%' === pointScrollType ) {
							if ( 'up' === self.sDirection && self.getScrollPercent() < (initScrollPercent - pointScrollPosition) ) {
								self.closePopup(popup);
							}
							if ( 'down' === self.sDirection && self.getScrollPercent() >= (initScrollPercent + pointScrollPosition) ) {
								self.closePopup(popup);
							}
						}
					});
				}
			},

			openPopup: function( e ) {
				var popup = (e instanceof Event) ? this : e;

				// Hide body scroll
				if ( popup.dataset.bodyScrollDisable === 'true' ) {
					document.body.classList.add('popup-scroll-hidden');
				}

				// Set Cookie of Limit display
				var limit = parseInt(self.getCookie('popup-' + getData(popup, 'id')) || 0) + 1;
				self.setCookie('popup-' + getData(popup, 'id'), limit, {
					expires: getData(popup, 'limit-lifetime')
				});

				if ( popup.classList.contains('popup-open') ) return;
				if ( popup.classList.contains('popup-already-opened') ) return;

				// Display popup
				popup.classList.add('popup-open');

				// Set current scroll
				setData(popup, 'init-scroll-px', window.scrollY);
				setData(popup, 'init-scroll-percent', self.getScrollPercent());

				// Open animation
				var animation = getData(popup, 'open-animation');
				self.applyAnimation(popup, animation);

				// Init close trigger
				self.closeTriggerPopup(popup);
			},

			agePopup: function( e ) {
				var el = (e instanceof Event) ? e.currentTarget : e;
				var popup = el.closest('.popup');
				if (!popup) return;
				self.setCookie('popup-age-' + getData(popup, 'id'), 1, { expires: 360 });
			},

			ageDeclined: function() {
				var q = document.querySelector('.age-verification__question');
				var d = document.querySelector('.age-verification__declined');
				if (q) q.classList.remove('show');
				if (d) d.classList.add('show');
			},

			acceptPopup: function( e ) {
				var el = (e instanceof Event) ? e.currentTarget : e;
				var popup = el.closest('.popup');
				if (!popup) return;
				self.setCookie('popup-accept-' + getData(popup, 'id'), 1, { expires: 360 });
			},

			closePopup: function( e ) {
				var el = (e instanceof Event) ? e.currentTarget : e;
				var popup = el.closest('.popup');
				if (!popup) popup = el;

				var animation = getData(popup, 'exit-animation');

				self.applyAnimation(popup, animation, function() {
					popup.classList.add('popup-already-opened');
					popup.classList.remove('popup-open');
					document.body.classList.remove('popup-scroll-hidden');
				});
			},

			isAllowPopup: function( e ) {
				var popup = (e instanceof Event) ? this : e;
				var limitDisplay = parseInt(getData(popup, 'limit-display') || 0);
				var limitDisplayCookie = parseInt(self.getCookie('popup-' + getData(popup, 'id')));

				if ( limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay ) {
					return false;
				}
				return true;
			},

			applyAnimation: function( el, name, callback ) {
				var popup = el.closest('.popup') || el;
				var overlayName = (typeof callback === 'function') ? 'popupExitFade' : 'popupOpenFade';

				// Overlay animation
				var overlay = nextSibling(popup, '.popup-overlay');
				if (overlay) {
					overlay.classList.add('popup-animated', overlayName);
					overlay.addEventListener('animationend', function handler() {
						overlay.removeEventListener('animationend', handler);
						overlay.classList.remove('popup-animated', overlayName);
					});
				}

				// Wrap animation
				var wrap = popup.querySelector('.popup-wrap');
				if (wrap && name) {
					wrap.classList.add('popup-animated', name);
					wrap.addEventListener('animationend', function handler() {
						wrap.removeEventListener('animationend', handler);
						wrap.classList.remove('popup-animated', name);
						if (typeof callback === 'function') callback();
					});
				} else if (typeof callback === 'function') {
					callback();
				}
			},

			getCookie: function( name ) {
				var matches = document.cookie.match( new RegExp(
					"(?:^|; )" + name.replace( /([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1' ) + "=([^;]*)"
				) );
				return matches ? decodeURIComponent( matches[ 1 ] ) : undefined;
			},

			setCookie: function( name, value, options ) {
				options = options || {};
				options.path = options.hasOwnProperty('path') ? options.path : '/';
				options.expires = parseInt(options.expires);

				if ( typeof options.expires == "number" && options.expires ) {
					options.expires = new Date( new Date().setDate(new Date().getDate() + options.expires) ).toUTCString();
				}

				value = encodeURIComponent(value);
				var updatedCookie = name + "=" + value;

				for ( var propName in options ) {
					updatedCookie += "; " + propName;
					var propValue = options[propName];
					if ( propValue !== true ) {
						updatedCookie += "=" + propValue;
					}
				}

				document.cookie = updatedCookie;
			},

			getScrollPercent: function() {
				var h = document.documentElement,
					b = document.body,
					st = 'scrollTop',
					sh = 'scrollHeight';
				return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
			}
		};

	} )();

	// Initialize
	adpPopup.init();

	document.addEventListener('shopify:section:load', function () {
		adpPopup.init();
	});

	document.addEventListener('shopify:section:unload', function () {
		document.body.classList.remove('popup-scroll-hidden');
	});
});
